module.exports = __webpack_public_path__ + "img/T5-C-xh14.00bac014.png";